// src/Pages/PaymentDateGroupMaster.jsx
import { useState } from "react";
import { savePaymentDateGroup } from "../Api/PaymentDateGroupMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const PaymentDateGroupMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [groupData, setGroupData] = useState({
    code: "",
    description: "",
  });

  const handleChange = (e) => {
    setGroupData({ ...groupData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await savePaymentDateGroup(groupData);
      toast.success("🦄 Payment Date Group Added Successfully");
      setGroupData({
        code: "",
        description: "",
      });
      navigate("/viewPaymentDateGroupMaster");
    } catch (error) {
      toast.error("🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Payment Date Group Master</h2>
            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="code"
                      value={groupData.code}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={groupData.description}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default PaymentDateGroupMaster;
